import { APIResponse, ConfigurableAppMutationArgs, User, useUserLoginMutation } from '@alluradirect/react';

export const useAppUserLoginMutation = ({ ...args }: ConfigurableAppMutationArgs = {}) => {
  return useUserLoginMutation({
    onSuccess: ({ DATA: { USER, POST_LOGIN_REDIRECT } }: APIResponse<{ USER: User, POST_LOGIN_REDIRECT: string }>) => {
      // The Lucee login returns the User Data Transfer Object which includes the GUEST_PROFILE / OWNER_PROFILE
      args.onSuccess && args.onSuccess(USER, POST_LOGIN_REDIRECT);
    },
  });
};
